module.exports = __webpack_public_path__ + "media/images/favicons/favicon-192x192-4b15bbcd308287773f535e3b1429906c.png";